<template>
  <div class="orderDetailPage">
    <!-- 订单内容 -->
    <div class="orderDiv" v-if="showPage">
      <div class="qishangflexTop">
        <div class="orderTop">
          <!-- //头部 -->
          <van-nav-bar
            title="订单详情"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
          />
          <!-- 订单选择框 -->
          <div
            class="vanDiv"
            v-if="orderOpen == 1 || orderOpen == 2 || orderOpen == 4"
          >
            <van-tabs @click="checkTab" v-model="orderNumber">
              <van-tab
                sticky
                id="vanTab"
                v-for="index in orderList && orderList.length"
                :title="'订单 ' + index"
                :key="index"
              >
              </van-tab>
            </van-tabs>
          </div>
        </div>
      </div>
      <!-- 正常显示 -->
      <div class="orderS" v-if="orderOpen == 1">
        <div class="vatDiv">
          <!-- 图片，订单 -->
          <div class="dlDiv">
            <dl>
              <dt>
                <img :src="thumbnailSrc" alt="" />
              </dt>
              <dd>
                <!-- <div>卡号：{{ checkOrder && checkOrder.orderNo }}</div> -->
                <div>
                  卡种名称：非记名DIY卡
                  <!-- {{ checkOrder && checkOrder.cardTypeName }} -->
                </div>
              </dd>
            </dl>
          </div>
          <div style="width: 100%; height: 10px; background: #eee"></div>
          <!-- 订单 -->
          <div class="orderThree">
            <div>下单时间：{{ checkOrder && checkOrder.orderDateTime }}</div>
            <div>
              订单名称：个性化卡申请
              <!-- {{ checkOrder && checkOrder.cardTypeName }} -->
            </div>
            <div>订单编号：{{ checkOrder && checkOrder.orderNo }}</div>
            <div>银行卡号：{{ checkOrder && checkOrder.bankCard }}</div>
            <div>邮寄地址：{{ checkOrder && checkOrder.address }}</div>
          </div>
          <div style="width: 100%; height: 10px; background: #eee"></div>
          <!-- 流程，物流信息 -->
          <div class="qishangflow">
            <div class="vanSteps">
              <van-steps direction="vertical" :active="activeNum">
                <van-step>
                  <div>
                    <span>
                      {{ step_1_desc }}
                    </span>
                  </div>
                </van-step>
                <van-step>
                  <div>
                    <span>{{ step_2_desc }}</span>
                    <span
                      v-show="
                        !showReason &&
                        checkOrder.orderStep == 2 &&
                        checkOrder.orderStatsNo == 1
                      "
                    >
                      您的卡面图片正在审核中，请您耐心等待，图片将在24小时内审核完成。
                    </span>
                    <!-- <span
                      v-show="
                        !showReason &&
                        checkOrder.orderStep == 2 &&
                        checkOrder.orderStatsNo == 8
                      "
                    >
                    </span> -->
                  </div>
                  <div v-show="showReason">
                    <hr />
                    <p>
                      抱歉您上传的卡面未通过审核。您可以在30天内“重新上传卡面”（无需再次缴费）或“取消订单”
                    </p>
                    <div>
                      未通过原因：<span style="color: red">{{
                        checkOrder.auditFailCause
                      }}</span>
                    </div>
                  </div>
                </van-step>
                <van-step>
                  <div style="margin-bottom: 5px">
                    <span>{{ step_3_desc }} </span>
                    <span
                      v-if="isLogistics"
                      class="isLogistics"
                      @click="changeLogistics"
                    >
                      <!-- {{
                        checkOrder.showWuliu
                          ? "点击收起物流单号>"
                          : "点击查看物流单号>"
                      }} -->
                    </span>
                  </div>
                  <span
                    v-show="
                      !showReason &&
                      checkOrder.orderStep == 3 &&
                      checkOrder.orderStatsNo == 2
                    "
                  >
                    你的卡片正在制卡中，请您耐心等待。卡片将在审核通过后20个工作日左右寄出到邮寄地址，请您及时领卡。
                  </span>
                  <span
                    v-if="isLogistics"
                    style="color: #888; font-size: 13px; margin-top: 5px"
                  >
                    您的卡片已寄出，请关注物流信息，保持电话畅通。<br />
                    物流公司：{{ checkOrder && checkOrder.courierCompany }}
                    <div
                      style="
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                      "
                    >
                      快递单号：{{ checkOrder && checkOrder.trackNumber }}
                      <van-button
                        type="info"
                        size="mini"
                        class="order-id"
                        :data-clipboard-text="
                          checkOrder && checkOrder.trackNumber
                        "
                        @click="copyText"
                        >复制</van-button
                      >
                    </div>
                    可微信登录EMS小程序或拨打11183查询物流进度
                  </span>
                </van-step>
                <!-- <van-step>
                  <div>{{ step_4_desc }}</div>
                </van-step> -->
              </van-steps>
            </div>
          </div>
          <!-- 订单操作 -->
          <div class="orderOper">
            <div class="box" v-show="showReason" style="margin: 10px 0">
              <div class="boxItem">
                <b-button block variant="primary" @click="showCancelConfirm()"
                  >取消订单</b-button
                >
              </div>
              <div class="boxItem">
                <b-button block variant="primary" @click="reupload()"
                  >重新上传卡面</b-button
                >
              </div>
            </div>

            <div class="box" v-show="showUnpayAction" style="margin: 10px 0">
              <div class="boxItem">
                <b-button block variant="primary" @click="showCancelConfirm()"
                  >取消订单</b-button
                >
              </div>
              <div class="boxItem">
                <b-button block variant="primary" @click="toOrderPay()"
                  >订单支付</b-button
                >
              </div>
            </div>
          </div>
          <!--v-if="checkOrder.orderStatsNo == 6"-->
          <div class="issue" @click="openIssue">>>发票开具入口</div>
        </div>
      </div>
      <!-- 订单已关闭状态 -->
      <div class="closeOrder" v-if="orderOpen == 2">
        <div class="close">
          <img src="static/qsbank/img_order_result.png" alt="" />
          <div>订单已关闭</div>
          <div style="font-size: 14px; color: red; margin-top: 10px">
            {{
              checkOrder.auditFailCause == null ? "" : checkOrder.auditFailCause
            }}
          </div>
          <!-- 10：已退款，4：退款进行中 -->
          <div
            v-if="checkOrder.orderStatsNo == 10 || checkOrder.orderStatsNo == 4"
            style="
              font-size: 14px;
              color: #333333;
              font-weight: 400;
              margin-top: 2px;
            "
          >
            <span v-if="checkOrder.orderStatsNo == 4">
              您的退款将在5个工作日内原支付渠道退回，请注意查收<br />
            </span>
            <br />
            {{ checkOrder.orderStatus }}
          </div>
          <div style="margin-top: 10px">
            <van-button
              class="refBtn"
              type="info"
              size="small"
              @click="refOrder(checkOrder)"
              >刷新</van-button
            >
          </div>
        </div>
      </div>
      <!-- 无订单信息 -->
      <div class="noOrderDiv" v-if="orderOpen == 3">
        <div class="qishangHint">
          <div>您还没有相关订单~</div>
          <van-button class="refBtn" type="info" size="small" @click="refOrder"
            >刷新</van-button
          >
        </div>
      </div>
    </div>

    <b-container>
      <!-- loading toast -->
      <div v-show="loading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <i class="weui-loading weui-icon_toast"></i>
          <p class="weui-toast__content">加载中</p>
        </div>
      </div>
      <b-modal
        ref="model_cancel_confirm"
        title="提示"
        @ok="handleCancelOrder"
        ok-title="取消"
        cancel-title="暂不取消"
      >
        <b-row>
          <b-col cols="10" class="mx-auto"> 确认取消订单？ </b-col>
        </b-row>
      </b-modal>

      <b-modal
        ok-only
        ref="model_cancel_result"
        title="提示"
        @ok="handeCancelResult"
        ok-title="确定"
      >
        {{ cancelResult }}
      </b-modal>
      <!-- 无申请卡数据 -->
      <b-modal
        ok-only
        ref="model_error"
        title="提示"
        @ok="handleOk()"
        ok-title="确定"
      >
        <p class="my-4">{{ errorMsg }}</p>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
import Clipboard from "clipboard";
export default {
  name: "OrderList_qs",
  data() {
    return {
      showPage: true, //有申请卡数据显示
      orderOpen: null, //当前订单是否关闭，1：正常显示，2：订单已关闭，3：无订单信息
      thumbnailSrc: "", //申请卡图片
      orderList: null, //用户申请卡数量
      checkOrder: null, //当前选中的用户申请卡内容
      orderNumber: 0, //订单编号下标
      projectName: "DIY",
      orders: [],
      loading: false,
      showToast: false,
      toastMsg: "",
      pageIndex: 1,
      pageSize: 10,
      queryOrderParam: null, //查询数据，暂时存储
      hasMoreData: false,
      busy: false,
      errorMsg: "",
      active: "",

      step_1_desc: "申请提交",
      step_2_desc: "制卡完成",
      step_3_desc: "寄出卡片",
      step_4_desc: "开卡成功",
      isLogistics: false, //是否显示物流信息按钮
      showReason: false, //审核未通过，取消订单、重新上传
      showUnpayAction: false, //取消订单、订单支付
      cancelResult: "",
      activeNum: 0, //制卡流程已到步骤，默认申请提交
    };
  },
  watch: {
    hasMoreData: function (newvalue, oldvalue) {
      console.log("hasMoreData new:" + newvalue + "," + "old:" + oldvalue);
    },
  },
  methods: {
    //复制
    copyText() {
      var clipboard = new Clipboard(".order-id"); //绑定数据标签的类名
      clipboard.on("success", (e) => {
        this.$toast({
          message: "复制成功",
          position: "top",
        });
        // this.$notify({ type: "success", message: "复制成功" });
        // console.log("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$toast({
          message: "该浏览器或手机权限不支持复制功能",
          position: "top",
        });
        // this.$notify({ type: 'success', message: '该浏览器或手机权限不支持复制功能' });
        // console.log("该浏览器或手机权限不支持复制功能");
        // 释放内存
        clipboard.destroy();
      });
    },
    //返回按钮
    onClickLeft() {
      this.$router.go(-1);
    },
    //取消订单
    showCancelConfirm: function () {
      this.$refs["model_cancel_confirm"].show();
    },
    handeCancelResult: function () {
      this.$router.go(-1);
    },
    showCancelResult: function () {
      this.$refs["model_cancel_result"].show();
    },
    //点击按钮，是否显示物流信息
    changeLogistics() {
      this.checkOrder.showWuliu = !this.checkOrder.showWuliu;
    },
    //确认取消订单弹框显示
    handleCancelOrder: function () {
      this.cancelOrder();
    },
    //   确认取消订单？
    cancelOrder: function () {
      var that = this;
      axios
        .get(config.config_qs.refund, {
          params: {
            orderNo: this.checkOrder.orderNo,
          },
        })
        .then(function (response) {
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            that.cancelResult = data.message;
            // that.$bvToast.toast(data.message, {
            //   title: '提示',
            //   autoHideDelay: 3000,
            //   toaster: 'b-toaster-bottom-center'
            // })
            // setTimeout(function() {
            //   that.$router.go(-3)
            // })
          } else {
            that.cancelResult = data.message;
            // that.$bvToast.toast(data.message, {
            //   title: '提示',
            //   autoHideDelay: 3000,
            //   toaster: 'b-toaster-bottom-center'
            // })
          }
          that.showCancelResult();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //无申请卡提示
    handleOk: function () {
      this.$router.go(-1);
    },
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    loadMore: function () {
      console.log(`loadMore事件`);
      this.busy = true;
      if (this.hasMoreData) {
        this.queryOrder();
      }
    },
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    checkTab(checkNum) {
      this.orderNumber = checkNum;
      localStorage.setItem("orderNumber", JSON.stringify(checkNum));
      this.getorderDetail(this.orderList[checkNum], "show");
    },
    //获取当前用户所有的开卡信息
    queryOrder: function () {
      //console.log(" this.queryOrderParam :>> ", this.queryOrderParam);
      let newArr = this.queryOrderParam.flowNo.split("|"); //分割字符串获取数组
      //console.log("newArr :>> ", newArr);
      var that = this;
      if (this.queryOrderParam.merchNo != config.config_qs.bankCode) {
        that.errorMsg = "银行编号有误：" + this.queryOrderParam.merchNo;
        that.showErrorMsg();
        return;
      }

      if (
        this.queryOrderParam.flowNo == undefined ||
        this.queryOrderParam.flowNo == ""
      ) {
        that.errorMsg = "银行流水号不能为空";
        that.showErrorMsg();
        return;
      }

      that.showLoading();
      axios
        .post(config.config_qs.queryOrder, {
          bankCodeModel: {
            bankCode: this.queryOrderParam.merchNo, //银行编号
            serialList: newArr, //流水号例:["060|9696"],
          },
          pageIndex: 1,
          pageSize: 100,
        })
        .then(function (response) {
          that.hideLoading();
          that.busy = false;
          console.log(response);
          // response.status = 201;
          if (response && response.status == 200) {
            var data = response.data;
            var dataString = JSON.stringify(data);
            //   console.log(dataString);

            if (data && data.code == 0) {
              that.orderOpen = 1; //正常显示
              that.pageIndex++;
              console.log("pageIndex:" + that.pageIndex);
              data.orderModelList.forEach((item, index) => {
                item.showWuliu = false;
              });
              let tempOrders = data.orderModelList;
              that.orderList = data.orderModelList; //赋值
              that.orderOpen = 1; //有数据正常显示
              console.log("that.orderNumber :>> ", that.orderNumber);
              // debugger
              that.getorderDetail(data.orderModelList[that.orderNumber]); //默认获取数据
              localStorage.setItem(
                "orderNumber",
                JSON.stringify(that.orderNumber)
              );
              // that.showPage = true; //有数据显示页面
              that.orders.push.apply(that.orders, tempOrders);
              if (tempOrders.length == 4) {
                //数量超过四个
                console.log(`tempOrders.length == 4`);
                that.hasMoreData = true;
              } else {
                that.hasMoreData = false;
              }
            } else {
              that.orderOpen = 3; //订单已关闭状态
            }
          } else {
            that.$toast.fail("请求失败，请重新查询");
          }
        })
        .catch(function (error) {
          that.hideLoading();
          that.busy = false;
          that.hasMoreData = false;
          console.log(error);
          that.$toast.fail("请求失败，请重新查询");
        });
    },
    //默认获取第一个订单内容,后者根据点击获取内容
    getorderDetail(data, show) {
      // 步骤二2-->1:审核中，3：审核未通过，8：正在制卡
      // 步骤三3-->9：卡已寄出
      // data.orderStep = 3; //流程步骤：测试未通过状态 2：审核未通过，0-1：未支付、申请提交,3:显示物流信息，4：开卡成功
      // data.orderStatsNo = 8; //订单状态及编号：测试未通过状态 6：订单关闭，4：退款进行中，10：已退款,5：未支付，3：审核未通过，8:正在制卡,
      console.log(`订单详情`, data);
      data.bankCard = this.hidden(data.bankCard + "", 4, 4);
      this.checkOrder = data;
      this.thumbnailSrc = config.config_qs.baseImgUrl + data.thumbnailFileUrl; //用户申请卡的图片

      if (
        data.orderStatsNo == 6 ||
        data.orderStatsNo == 10 ||
        data.orderStatsNo == 4
      ) {
        this.orderOpen = 2; //订单已关闭状态
        return;
      } else {
        this.orderOpen = 1; //1、订单正常显示，2、订单已关闭状态，3、无订单
      }
      if (data != null) {
        switch (data.orderStep) {
          case 0:
          case 1:
            break;
          case 2: //审核中、审核不通过、审核通过
            this.activeNum = 1;
            this.isLogistics = false; //未走到寄出卡片流程，关闭物流信息
            if (data.orderStatsNo == 3) {
              this.step_2_desc = "审核未通过";
            }
            if (data.orderStatsNo == 1) {
              this.step_2_desc = "审核中";
            }
            break;
          case 3: //正在制卡
            this.isLogistics = false; //走到寄出卡片流程，显示物流信息
            this.activeNum = 2;
            this.step_3_desc = data.orderStatus;
            this.step_2_desc = "审核通过";
            if (data.orderStatsNo == 2) {
              this.step_3_desc = "正在制卡";
            }
            // if (data.orderStatsNo == 9 || data.orderStatsNo == 8) {
            //   this.step_3_desc = "卡已寄出";
            //   this.isLogistics = true; //走到寄出卡片流程，显示物流信息
            // }
            break;
          case 4: //开卡成功、卡已寄出
            // this.isLogistics = false; //未走到寄出卡片流程，关闭物流信息
            // this.activeNum = 3;
            // this.step_2_desc = "审核通过"; //审核通过
            // this.step_3_desc = "卡已寄出"; //已制卡
            // break;
            this.isLogistics = false; //走到寄出卡片流程，显示物流信息
            this.activeNum = 2;
            this.step_3_desc = data.orderStatus;
            this.step_2_desc = "审核通过";
            // if (data.orderStatsNo == 2) {
            //   this.step_3_desc = "正在制卡";
            // }
            if (data.orderStatsNo == 9 || data.orderStatsNo == 8) {
              this.step_3_desc = "卡已寄出";
              this.isLogistics = true; //走到寄出卡片流程，显示物流信息
            }
            break;
        }

        //审核未通过
        if (data.orderStep == 2 && data.orderStatsNo == 3) {
          this.showReason = true;
        } else {
          this.showReason = false;
        }
        //未支付
        if (data.orderStep == 0 && data.orderStatsNo == 5) {
          this.showUnpayAction = true;
        } else {
          this.showUnpayAction = false;
        }
      }

      var that = this;
      if (show && show == "show") {
        that.showLoading();
      }
      that.hideLoading();
    },
    hidden(str, frontLen, endLen) {
      //str：要进行隐藏的变量  frontLen: 前面需要保留几位    endLen: 后面需要保留几位
      var len = str.length - frontLen - endLen;
      var xing = "";
      for (var i = 0; i < len; i++) {
        xing += "*";
      }
      return (
        str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
      );
    },
    //订单支付
    toOrderPay: function () {
      /* {
               orderNo: '01248790113566597120',
               orderDateTime: '2020-05-22 09:39:22',
               price: 1,
               projectName: 'DIY',
               thumbnailFileUrl: ''
             } */
      var obj = {
        orderNo: this.checkOrder.orderNo, //订单编号
        orderDateTime: this.checkOrder.orderDateTime,
        price: this.checkOrder.price,
        projectName: this.projectName,
        thumbnailFileUrl: this.checkOrder.thumbnailFileUrl,
        bankCode: this.checkOrder.bankCode,
        isPayed: false,
        deadline: this.checkOrder.deadline,
        cardTypeId: this.checkOrder.cardTypeId, //1-借记卡 / 2-信用卡
      };
      console.log(`订单支付`, obj);

      var orderInfo = JSON.stringify(obj);
      this.$router.replace({
        name: "OrderPay_qs",
        params: {
          orderInfo: orderInfo,
        },
      });
    },
    //重新上传卡面
    reupload: function () {
      var param = {
        isModify: 1,
        orderNo: this.checkOrder.orderNo,
        backgroundColor: this.checkOrder.backgroundColor,
        cardOri: this.checkOrder.modelClass,
        isPayed: true,
      };
      console.log(`重新上传卡面`, param);

      var selectParam = JSON.stringify(param);
      console.log("selectParam:" + selectParam);
      this.$router.replace({
        name: "SelectCardface_qs",
        params: {
          selectParam: selectParam,
        },
      });
    },
    //刷新订单
    refOrder(data) {
      if (data && data) {
        this.queryOrder(); //只获取当前订单信息
      } else {
        this.queryOrder(); //获取所有订单信息
      }
    },
    //开具发票
    openIssue() {
      this.$router.push({
        name: "Invoice_qs",
        params: {
          data: this.checkOrder,
        },
      });
    },
  },
  mounted: function () {
    var result = this.$route.params;
    // console.log("result :>> ", result);
    // this.queryOrderParam = result;
    // this.queryOrder();

    var result = this.$route.params;
    console.log("result :>> ", result);
    if (result != undefined && JSON.stringify(result) != "{}") {
      // var obj = JSON.parse(result);
      localStorage.setItem("queryOrderParam", JSON.stringify(result));
      this.queryOrderParam = result;
      console.log("queryOrderParam:" + this.queryOrderParam);
      this.queryOrder();
    } else {
      let result = localStorage.getItem("queryOrderParam");
      let orderNum = localStorage.getItem("orderNumber");
      var obj = JSON.parse(result);
      var obj1 = JSON.parse(orderNum);
      this.queryOrderParam = obj;
      this.orderNumber = obj1;
      this.queryOrder();
    }
  },
};
</script>

<style lang="less" scoped>
.orderDetailPage {
  background: #fff;
  .orderDiv {
    width: 100%;
    height: 100%;
    z-index: 100;
    .qishangflexTop {
      width: 100%;
      height: 100px;
      background: #fff;
      .orderTop {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        width: 100%;
        height: 100px;
        background: #fff;
        .vanDiv {
          width: 100%;
          height: 50px;
          border-bottom: 1px solid #ccc;
        }
      }
    }
    .orderS {
      width: 100%;
      height: 100%;
      .vatDiv {
        overflow-y: scroll;
        width: 100%;
        height: 100%;
        .dlDiv {
          width: 100%;
          padding: 0 10px;
          // border-bottom: 1px solid #ccc;
          background: #fff;
          dl {
            padding: 5px 5px 0 5px;
            display: flex;
            dt {
              width: 30%;
              img {
                width: 100%;
                height: 100%;
                border-radius: 5px;
              }
            }
            dd {
              flex: 1;
              padding: 0 5px;
              div {
                margin-top: 5px;
              }
            }
          }
        }
        .orderThree {
          background: #fff;
          width: 100%;
          padding: 5px 15px;
          div {
            margin-top: 5px;
          }
        }
        .qishangflow {
          margin-top: 10px;
          background: #fff;
          padding: 5px 15px;
          .vanSteps {
            .isLogistics {
              padding-left: 5px;
              color: blue;
              cursor: pointer;
            }
          }
        }
        .orderOper {
          background: #fff;
          padding-top: 10px;
        }
        .issue {
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #000;
          float: right;
          margin-right: 20px;
          margin-bottom: 20px;
        }
      }
    }
    .closeOrder {
      width: 100%;
      background: #fff;
      .close {
        width: 100%;
        margin-top: 100px;
        text-align: center;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
        color: #000;
        text-shadow: 0 1px 0 #fff;
        opacity: 0.5;
        img {
          width: 30%;
          height: 100px;
          margin-bottom: 10px;
          margin: auto;
        }
        // .issue {
        //   text-align: center;
        //   font-size: 14px;
        //   font-weight: 400;
        //   color: #000;
        //   float: right;
        //   margin-right: 20px;
        //   margin-top: 20px;
        // }
      }
    }
    .noOrderDiv {
      width: 100%;
      background: #fff;
      .qishangHint {
        text-align: center;
        padding-top: 200px;
        .refBtn {
          margin-top: 10px;
          padding: 2px 20px;
        }
      }
    }
  }
}

// .van-tabs__wrap--scrollable .van-tab {
//   width: 50%;
//   background: red;
//   color: green;
// }
</style>



// WEBPACK FOOTER //
// src/components/qishangbank/OrderDetails_qs.vue